import safeHtml from 'Helpers/safeHtml'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import LineNextToStep from 'Components/LineNextToStep/LineNextToStep'
import {
  Badge,
  BADGE_KIND_SECONDARY,
  BADGE_TYPE_DEFAULT,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  Panel,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'

import { workflowState } from 'Pages/WorkflowStatistics/recoil/state/workflow'

const StartStep = ({ hasTriggered }) => {
  const intl = useIntl()

  const { conditionsDescription } = useRecoilValue(workflowState)

  return (
    <Flex width='100%' minWidth='800px'>
      <FlexItem margin='0 32px 0 0' width='26px'>
        <LineNextToStep isDisabled={!hasTriggered} isFirst />
      </FlexItem>
      <FlexItem width='100%'>
        <Panel data-mu-test='workflow-statistics__panel__step-start'>
          <Grid cols={12}>
            <GridCell span={7}>
              <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DragWorkflowStart'
                })}
              </Text>{' '}
              {safeHtml(conditionsDescription.StartCondition)}
            </GridCell>
            {!hasTriggered && (
              <GridCell span={5}>
                <Badge
                  data-mu-test='workflow-statistics__badge__step-start-not-triggered'
                  kind={BADGE_KIND_SECONDARY}
                  type={BADGE_TYPE_DEFAULT}
                  text={intl.formatMessage({
                    id: 'Load.AutomationWorkflowTroubleshooting.ConditionNeverHappened'
                  })}
                />
              </GridCell>
            )}
          </Grid>
        </Panel>
      </FlexItem>
    </Flex>
  )
}
export default StartStep

StartStep.propTypes = {
  hasTriggered: PropTypes.bool
}
